import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Cross, Zostel } from "../../../../assets/media/icons";

import ArrowDown from "../../../../assets/media/icons/ArrowDown";
import Homes from "../../../../assets/media/icons/Homes";
import ZoTrip from "../../../../assets/media/icons/ZoTrip";
import Menu from "../../../../assets/media/svgs/Menu";
import ZostelLogo from "../../../../components/svg/ZostelLogo";
import { Login } from "../../../../components/ui/Login";
import { AuthContext } from "../../../../contexts/auth";
import { ProfileContext } from "../../../../contexts/profile";
import { AuthContext as ZoAuthContext } from "../../../../contexts/zoauth";
import { GeneralObject } from "../../../../definitions/general";
import {
  useUnauthenticatedApi,
  useZoUnauthenticatedApi,
} from "../../../../hooks/useApi";
import CustomModal from "../../pages/UserAccount/components/CustomModal";
import Navigation from "../Navigation";
import SearchBarHeader from "../Navigation/components/SearchBar/SearchBarHeader";

interface NavItem {
  id: number;
  title: string;
  image: string;
  navTitle: string;
  link: string;
  icon: React.ReactNode;
  items?: { label: string; to: string }[];
  region?: { name: string }[];
}
const formatDropdownLinks = (ops: any[], type: string) => {
  return ops.map((op) => ({
    to: op.destination?.slug
      ? `/${type}/${op.destination?.slug}/${op.slug}`
      : `/${type}/${op.slug}`,
    label: op.name,
    region: op.destination?.region,
  }));
};

const Header: React.FC<any> = ({ absolute, theme, sticky, isStickyMobile }) => {
  const [hostels, setHostels] = useState<any[]>([]);
  const [homes, setHomes] = useState<any[]>([]);
  const [plus, setPlus] = useState<any[]>([]);
  const [trips, setTrips] = useState<any[]>([]);
  const operatorsApi = useUnauthenticatedApi("STAY_OPERATORS");
  const zoTripApi = useZoUnauthenticatedApi("BOOKING_TRIPS_INVENTORIES");

  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const [loginDropdownOpen, setLoginDropdownOpen] = useState<boolean>(false);
  const loginDropdownRef = useRef<HTMLDivElement>(null);
  const { isLoggedIn, logout } = useContext(AuthContext);
  const { logout: logoutZo } = useContext(ZoAuthContext);
  const { zoProfile } = useContext(ProfileContext);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showTravelAlert, setShowTravelAlert] = useState<boolean>(true);

  useEffect(() => {
    operatorsApi
      .get("?operating_model=F&fields=name,slug,destination,type_code")
      .then((res) => {
        setHostels(
          formatDropdownLinks(
            res.data.operators.filter(
              (k: GeneralObject) => k.type_code === "H"
            ),
            "zostel"
          )
        );
        setPlus(
          formatDropdownLinks(
            res.data.operators
              .filter((k: GeneralObject) => k.type_code === "P")
              .slice(0, 16),
            "zostel"
          )
        );
        setHomes(
          formatDropdownLinks(
            res.data.operators
              .filter((k: GeneralObject) => k.type_code === "B")
              .slice(0, 16),
            "zostel"
          )
        );
      })
      .catch(console.log);
  }, [operatorsApi]);

  useEffect(() => {
    zoTripApi
      .get("?limit=16")
      .then((res) => {
        setTrips(formatDropdownLinks(res.data.results, "trips"));
      })
      .catch(console.log);
  }, [zoTripApi]);

  const navItems: NavItem[] = [
    {
      id: 1,
      image: `${process.env.REACT_APP_IMAGE_PROXY_URL}/gallery/media/images/52078ee6-7a97-44c5-bb0f-fb0e43f8876c_20250311034613.jpg?w=320`,
      title: "Vibrant backpacker hostels for a social, eventful getaway",

      navTitle: "Zostel",
      link: "/zostel",
      icon: <Zostel className="w-4 h-4" fill="#F15824" />,
      items: hostels,
      region: hostels[0]?.region,
    },
    {
      id: 2,
      image: `${process.env.REACT_APP_IMAGE_PROXY_URL}/gallery/media/images/95754cf7-d49a-4d12-b3bc-06169d4be8b3_20250311034003.png?w=320`,
      title: "Premium hostels with aesthetic spaces and curated experiences",
      navTitle: "Zostel Plus",
      link: "/zostel-plus",
      icon: <Zostel className="w-4 h-4" />,
      items: plus,
      region: plus[0]?.region,
    },
    {
      id: 3,
      image: `${process.env.REACT_APP_IMAGE_PROXY_URL}/gallery/media/images/d7ff46e8-fc0d-4501-837a-f98ef0a39878_20250311034048.jpg?w=320`,
      title:
        "Family friendly home stays, villas & more, for a private, offbeat escape",
      navTitle: "Homes",
      link: "/homes",
      icon: <Homes className="w-4 h-4" />,
      items: homes,
      region: homes[0]?.region,
    },
    {
      id: 4,
      image: `${process.env.REACT_APP_IMAGE_PROXY_URL}/gallery/media/images/3655e933-e584-4ac9-92dd-f3056e00362c_20250122145135.png?w=320`,
      title:
        "All-inclusive domestic and international tours with handcrafted itineraries",
      navTitle: "Zo Trips",
      link: "/zo-trips",
      icon: <ZoTrip className="w-4 h-4" />,
      items: trips,
      region: trips[0]?.region,
    },
  ];

  const handleLogout = () => {
    logout();
    logoutZo();
  };

  const openLoginModal = () => setShowLoginModal(true);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setMobileMenuOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    // Add click outside listener for login dropdown
    const handleClickOutside = (event: MouseEvent) => {
      if (
        loginDropdownRef.current &&
        !loginDropdownRef.current.contains(event.target as Node)
      ) {
        setLoginDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dismissTravelAlert = () => {
    setShowTravelAlert(false);
    localStorage.setItem("dismissedTravelAlert", "true");
  };

  useEffect(() => {
    const dismissedTravelAlert = localStorage.getItem("dismissedTravelAlert");
    if (dismissedTravelAlert) {
      setShowTravelAlert(false);
    }
  }, []);

  const handleMouseEnter = (id: number) => {
    if (!isMobile) {
      setActiveDropdown(id);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setActiveDropdown(null);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleMobileDropdown = (id: number) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };

  const toggleLoginDropdown = () => {
    setLoginDropdownOpen(!loginDropdownOpen);
  };

  const getHeaderClassName = () => {
    if (sticky || isStickyMobile) return "sticky bg-white ";
    if (absolute) return "absolute";
    return "relative bg-white";
  };

  const closeLoginModal = () => setShowLoginModal(false);

  return (
    <header
      className={`${getHeaderClassName()} top-0 left-0 z-20  w-full border-b border-stroke-primary`}
    >
      {/* Top header with logo, search and login */}
      <div className="px-6 sm:px-28 my-5 md:my-0 md:pt-3  ">
        <div className="flex items-center justify-between">
          {/* Logo - Left side */}
          <Link to="/" className="flex items-center">
            <ZostelLogo
              className="relative z-10 h-8 w-36"
              textClassName={
                theme === "dark"
                  ? "fill-current text-white"
                  : "fill-current text-dark"
              }
            />
          </Link>

          {/* Search - Center (desktop only) */}
          <div className="hidden md:flex flex-1 justify-center mx-auto">
            <SearchBarHeader />
          </div>

          {/* Login and Mobile Menu - Right side */}
          <div className="flex items-center space-x-3">
            {/* Get the App button - Desktop only */}
            <div className="hidden md:block">
              <Link
                to="/app"
                className="flex items-center space-x-2 px-4 py-2 rounded-full border border-stroke-primary hover:bg-light-grey transition-colors"
              >
                <span className="text-base" role="img" aria-label="mobile">
                  📱
                </span>
                <span className="text-sm font-medium">Get the App</span>
              </Link>
            </div>

            {/* Login and Mobile Menu container */}
            <div className="flex items-center gap-3 h-full">
              {/* Login with dropdown */}
              <div
                className="relative group flex items-center"
                ref={loginDropdownRef}
              >
                {isLoggedIn ? (
                  <div
                    className="flex items-center cursor-pointer hover:bg-light-grey gap-1 md:gap-2 px-1 py-1 rounded-full border border-stroke-primary"
                    onClick={toggleLoginDropdown}
                    onMouseEnter={() => !isMobile && setLoginDropdownOpen(true)}
                    onMouseLeave={() =>
                      !isMobile && setLoginDropdownOpen(false)
                    }
                  >
                    <>
                      {zoProfile?.avatar?.image ? (
                        <img
                          src={zoProfile.avatar.image}
                          alt="Profile"
                          className="w-6 h-6 md:w-8 md:h-8 rounded-full"
                        />
                      ) : (
                        <span
                          className="flex items-center justify-center w-6 h-6 md:w-8 md:h-8  border-2 border-stroke-primary rounded-full"
                          role="img"
                          aria-label="Profile"
                        >
                          😎
                        </span>
                      )}
                    </>

                    <ArrowDown
                      className={`w-4 h-4 ml-1 zostel-nav-arrow-transition ${
                        loginDropdownOpen ? "zostel-nav-arrow-rotated" : ""
                      }`}
                    />

                    {/* Login Dropdown */}
                    {loginDropdownOpen && (
                      <div className="absolute right-0   md:-mr-20 top-full pt-2 z-50">
                        <div className="w-48 bg-white shadow-md rounded-2xl">
                          <div className="py-2 px-2">
                            <Link
                              to="/me/profile"
                              className="block px-3 py-2 text-sm hover:bg-light-grey rounded-full"
                            >
                              <div className="flex items-center gap-3">
                                <span
                                  role="img"
                                  aria-label="Profile"
                                  className="text-base"
                                >
                                  😎
                                </span>
                                <span className="text-sm">Profile</span>
                              </div>
                            </Link>
                            <Link
                              to="/me/bookings"
                              className="block px-3 py-2 text-sm hover:bg-light-grey rounded-full"
                            >
                              <div className="flex items-center gap-3">
                                <span
                                  role="img"
                                  aria-label="cool"
                                  className="text-base"
                                >
                                  💼
                                </span>
                                <span className="text-sm">My Bookings</span>
                              </div>
                            </Link>
                            <button
                              onClick={handleLogout}
                              className="block focus:outline-none w-full text-left  px-3 py-2 text-sm hover:bg-light-grey rounded-full"
                            >
                              <div className="flex items-center gap-3">
                                <span
                                  role="img"
                                  aria-label="running"
                                  className="text-base"
                                >
                                  🏃
                                </span>
                                <span className="text-sm">Logout</span>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <button
                    className={`${
                      theme === "dark"
                        ? "bg-white text-primary"
                        : "bg-primary text-white hover:bg-orange"
                    } py-2 md:py-3 px-3 md:px-4 text-xs font-medium rounded-full focus:outline-none my-auto`}
                    onClick={openLoginModal}
                  >
                    Login
                  </button>
                )}
              </div>

              {/* Mobile menu button */}
              <div className="md:hidden flex items-center">
                <button
                  className="focus:outline-none my-auto"
                  onClick={toggleMobileMenu}
                >
                  <Menu className="w-6 h-6" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation component */}
      <Navigation
        navItems={navItems}
        isMobile={isMobile}
        mobileMenuOpen={mobileMenuOpen}
        activeDropdown={activeDropdown}
        handleMouseEnter={handleMouseEnter}
        handleMouseLeave={handleMouseLeave}
        toggleMobileMenu={toggleMobileMenu}
        toggleMobileDropdown={toggleMobileDropdown}
      />

      {showTravelAlert && (
        <div className="w-full px-6 flex bg-status-success items-center border-t border-stroke-primary justify-center py-2">
          <span className="text-base flex items-center gap-1 font-medium">
            <span role="img" aria-label="alert" className="text-sm">
              🟢
            </span>
          </span>
          <span className="text-xs sm:text-sm px-3">
            All flights have resumed. Do keep an eye on local advisories as you
            plan. Happy travelling!
          </span>
          <button
            onClick={dismissTravelAlert}
            className="text-xs cursor-pointer py-1 px-3 -mr-3 sm:mr-0 rounded-full border-stroke-primary font-medium sm:border border-gray-400 focus:outline-none"
          >
            <span className="hidden sm:block">Got it</span>
            <span className="block sm:hidden">
              <Cross className="w-4 h-4" />
            </span>
          </button>
        </div>
      )}

      <CustomModal
        isOpen={showLoginModal}
        onClose={closeLoginModal}
        title="Log in to Zo"
        width="392px"
      >
        <div className="flex justify-center items-center mb-6">
          <Login closeModal={closeLoginModal} />
        </div>
      </CustomModal>
    </header>
  );
};

export default Header;
